import { TenantPerformableFormProps } from '~/tenants/common/form';
import {
  TenantPackageAddOnCheckboxName,
} from '~/tenants/common/package';
import { MlmOrderContext } from '../../model/MlmOrder';
import { format_money } from '~/components/Money';
import { MLM_PHOTO_COMMUNITY } from './MlmPhotosJob';
import Big from 'big.js';
import { useZodFormFieldObject } from '~/components/zod/ZodForm';
import { DistanceAddress } from '~/lib/model';
import ZodFieldAddress from '~/components/zod/ZodFieldAddress';
import classNames from 'classnames';
import Button from '~/components/interactive/Button';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';

function communityExtraPhotos(count: number) {
  return {
    label: `15 Minute Shoot, ${count} Community Photos: ${format_money(new Big(MLM_PHOTO_COMMUNITY).toFixed(2))}`,
    value: count.toString(),
  };
}

function Address({ name, remove }: { name: string; remove: () => void }) {
  const [_name, address] = useZodFormFieldObject<DistanceAddress>(name);

  return (
    <div className="flex gap-4 align-baseline">
      <div
        className={classNames('', {
          'flex-1': !address?.city,
        })}
      >
        <ZodFieldAddress name={name} key={name} />
      </div>
      {address?.city && (
        <Button type="button" variant="outline" size="short" onClick={remove}>
          remove
        </Button>
      )}
    </div>
  );
}

export default function MlmPhotosCommunity({ persona }: Pick<TenantPerformableFormProps<MlmOrderContext>, 'persona'>) {
  return (
    <TenantPackageAddOnCheckboxName
      name="community"
      persona={persona}
      image="/tenant/mpi/community/1.jpg"
      cost={MLM_PHOTO_COMMUNITY}
      title="Community Photos"
      description="Our photographer will visit a location of your choice for 15 minutes and take 5-10 additional photos."
    >
      <FormHorizontal label="Instructions">
        <ZodFieldTextarea name="community_notes" />
      </FormHorizontal>
    </TenantPackageAddOnCheckboxName>
  );
}
